import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Text, Row } from '@simplywallst/ui-core';
import { StyledButton } from './styled';

export const LinkedPortfolioFeedbackBanner = () => {
  const makeTypeformPopup = useTypeformDrawer('Re3NqTzK');
  return (
    <Row noWrap alignItem="center">
      <Text typography="xSmall" color="whiteRGBA" opacity={0.5}>
        Exciting new features are on the way to help you achieve your portfolio
        goals 🚀{' '}
        <StyledButton
          as="a"
          styleType="strongLink"
          href="/help/articles/hc/en-us/articles/7461937035279-Building-the-new-portfolio-tool-Roadmap-"
          target="_blank"
        >
          Learn more
        </StyledButton>{' '}
        or{' '}
        <StyledButton
          styleType="strongLink"
          display="inline-block"
          onClick={makeTypeformPopup}
        >
          Leave feedback
        </StyledButton>
      </Text>
    </Row>
  );
};

export default LinkedPortfolioFeedbackBanner;
